import React from 'react';
import { Truck, Shield, CreditCard, Leaf } from 'lucide-react';
const InfoSection = () => {
  return <section className="py-20 bg-[#f8f9f4]" data-id="element-357">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-358">
        <div className="text-center mb-12" data-id="element-359">
          <h2 className="text-3xl font-bold text-gray-900 mb-4" data-id="element-360">
            Why Choose Our Oils
          </h2>
          <p className="text-gray-600 max-w-2xl mx-auto" data-id="element-361">
            Experience the difference with our premium essential oils, sourced
            directly from Kenya's pristine landscapes.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8" data-id="element-362">
          <div className="bg-white rounded-2xl p-8 text-center shadow-md hover:shadow-lg transition-all duration-300" data-id="element-363">
            <div className="inline-flex items-center justify-center w-16 h-16 bg-[#f0f7eb] text-[#2e7d32] rounded-full mb-6" data-id="element-364">
              <Leaf className="h-8 w-8" data-id="element-365" />
            </div>
            <h3 className="font-semibold text-gray-900 text-lg mb-3" data-id="element-366">
              100% Pure & Natural
            </h3>
            <p className="text-gray-600" data-id="element-367">
              Our essential oils are extracted through careful steam
              distillation and cold pressing, preserving their therapeutic
              properties.
            </p>
          </div>
          <div className="bg-white rounded-2xl p-8 text-center shadow-md hover:shadow-lg transition-all duration-300" data-id="element-368">
            <div className="inline-flex items-center justify-center w-16 h-16 bg-[#f0f7eb] text-[#2e7d32] rounded-full mb-6" data-id="element-369">
              <Shield className="h-8 w-8" data-id="element-370" />
            </div>
            <h3 className="font-semibold text-gray-900 text-lg mb-3" data-id="element-371">
              Quality Tested
            </h3>
            <p className="text-gray-600" data-id="element-372">
              Each batch undergoes rigorous testing to ensure purity, potency
              and consistency in every bottle we produce.
            </p>
          </div>
          <div className="bg-white rounded-2xl p-8 text-center shadow-md hover:shadow-lg transition-all duration-300" data-id="element-373">
            <div className="inline-flex items-center justify-center w-16 h-16 bg-[#f0f7eb] text-[#2e7d32] rounded-full mb-6" data-id="element-374">
              <Truck className="h-8 w-8" data-id="element-375" />
            </div>
            <h3 className="font-semibold text-gray-900 text-lg mb-3" data-id="element-376">
              Fast Delivery
            </h3>
            <p className="text-gray-600" data-id="element-377">
              We deliver across Kenya within 2-4 business days. International
              shipping available to select countries.
            </p>
          </div>
          <div className="bg-white rounded-2xl p-8 text-center shadow-md hover:shadow-lg transition-all duration-300" data-id="element-378">
            <div className="inline-flex items-center justify-center w-16 h-16 bg-[#f0f7eb] text-[#2e7d32] rounded-full mb-6" data-id="element-379">
              <CreditCard className="h-8 w-8" data-id="element-380" />
            </div>
            <h3 className="font-semibold text-gray-900 text-lg mb-3" data-id="element-381">
              Secure Payment
            </h3>
            <p className="text-gray-600" data-id="element-382">
              Shop with confidence using our secure payment methods, including
              credit cards and mobile money.
            </p>
          </div>
        </div>
      </div>
    </section>;
};
export default InfoSection;